import * as api from '../api';

/**
 * Gère l'action du bouton d'événement (placer ou créer)
 * @param {Event} e L'événement de clic
 */
function handleEventAction(e) {
    const btn = e.target.closest('.btn-event-action');
    if (!btn || !window.map) return;

    const lat = parseFloat(btn.dataset.lat);
    const lng = parseFloat(btn.dataset.lng);
    const isPlace = btn.id === 'btn-placeEvent';
    const map = window.map;

    if (isPlace && map.event) {
        // Placer le marqueur dans l'événement existant
        const event = map.event;
        let feature = event.features.find(f => (f.properties?.type?.name || f.properties?.type) === 'event');
        
        if (feature) {
            feature.geometry.coordinates = [lng, lat];
        } else {
            feature = {
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: [lng, lat]
                },
                properties: {
                    name: 'Evénement',
                    type: 'event'
                }
            };
            event.features.push(feature);
        }

        // Mettre à jour les données de localisation de l'événement
        api.getPointData({lat, lng}).then(data => {
            event.massif = data.mountain;
            event.tgi = data.tgi;
            event.com = data.name;
            event.alt = data.alt;

            api.saveEvent(event).then(updatedEvent => {
                M.toast({html: 'Evénement mis à jour', classes: 'green accent-4'});
                if (map._eventLayer) {
                    map._eventLayer.update(updatedEvent, {renderDetails: true});
                } else {
                    location.reload(); // Fallback si _eventLayer n'est pas dispo
                }
            });
        });
    } else if (!isPlace) {
        // Créer un nouvel événement
        api.getPointData({lat, lng}).then(data => {
            const newEvent = {
                name: '',
                massif: data.mountain,
                tgi: data.tgi,
                com: data.name,
                alt: data.alt,
                features: [{
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: [lng, lat]
                    },
                    properties: {
                        name: 'Evénement',
                        type: 'event'
                    }
                }]
            };

            api.saveEvent(newEvent).then(savedEvent => {
                M.toast({html: 'Evénement créé', classes: 'green accent-4'});
                const url = new URL(window.location.href);
                url.search = new URLSearchParams({
                    event: savedEvent.id,
                    lat: lat,
                    lng: lng,
                    zoom: 16
                }).toString();
                window.open(url.toString(), savedEvent.id).focus();
            });
        });
    }
}

// Ajouter le listener global une seule fois
if (!window._eventActionListenerAdded) {
    document.addEventListener('click', handleEventAction);
    window._eventActionListenerAdded = true;
}

/**
 * Handler du double click
 * @param {*} coor Coordonnées du double click
 * @param {*} map la carte courante
 */
export function dblclick(coor, map) {
    api.getPointData(coor).then(data => {
        L.popup({
            minWidth: 350,
            maxWidth: 500
        })
            .setLatLng(coor)
            .setContent(Handlebars.templates['dbclick-popup']({
                name: data.name ?? '--',
                service: data.service ?? '--',
                tgi: data.tgi ?? '--',
                alt: data.alt ?? '--',
                point: coor,
                isEventDetails: !!map.eventId
            }))
            .openOn(map);
    });
}